import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgCharitableContributions = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 16,
	height: 16,
	viewBox: "0 0 16 16",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	color: "#d5b29f",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M10.2009 9.38527C10.0096 9.57492 9.75106 9.68133 9.48165 9.68133C9.21224 9.68133 8.95373 9.57492 8.76238 9.38527L5.18619 5.74186C4.8127 5.38287 4.56464 4.91323 4.47869 4.40237C4.39274 3.89151 4.47346 3.36655 4.70892 2.90511C4.89618 2.54765 5.16465 2.23907 5.49276 2.00415C5.82088 1.76923 6.1995 1.61451 6.59824 1.55241C6.99697 1.49032 7.40472 1.52257 7.78873 1.64658C8.17274 1.7706 8.52233 1.98292 8.80944 2.2665L9.48165 2.93872L10.1539 2.2665C10.441 1.9883 10.7888 1.78059 11.1699 1.65975C11.551 1.5389 11.9549 1.50823 12.3499 1.57015C12.7449 1.63207 13.1201 1.78488 13.4459 2.01655C13.7717 2.24821 14.0393 2.55239 14.2275 2.90511C14.4663 3.3638 14.5514 3.88706 14.4703 4.39778C14.3892 4.90851 14.1462 5.37967 13.7771 5.74186L10.2009 9.38527Z",
			fill: "currentColor",
			fillOpacity: .25,
			stroke: "currentColor",
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M1.50024 12.4617L3.10011 13.8062C3.63503 14.2385 4.30129 14.4756 4.98904 14.4784L8.4644 14.4784C8.73182 14.4784 8.9883 14.3721 9.17739 14.183C9.36649 13.994 9.47272 13.7375 9.47272 13.4701C9.47272 13.3376 9.44664 13.2065 9.39597 13.0842C9.3453 12.9619 9.27103 12.8507 9.17739 12.7571C9.08376 12.6634 8.9726 12.5892 8.85027 12.5385C8.72793 12.4878 8.59682 12.4617 8.4644 12.4617L5.86965 12.4617",
			stroke: "currentColor",
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M1.50019 9.43671L3.51684 9.43671C4.11546 9.43541 4.70077 9.61335 5.19738 9.9476L6.37376 10.7139C6.48567 10.7789 6.58286 10.8665 6.65917 10.971C6.73548 11.0755 6.78924 11.1948 6.81704 11.3212C6.84485 11.4475 6.8461 11.5783 6.82071 11.7052C6.79531 11.8321 6.74383 11.9524 6.66953 12.0584C6.54175 12.2484 6.34906 12.3853 6.12755 12.4435C5.90604 12.5017 5.67093 12.4771 5.46627 12.3743L3.95378 11.4668",
			stroke: "currentColor",
			strokeLinecap: "round",
			strokeLinejoin: "round"
		})
	]
});
export default SvgCharitableContributions;
